module.exports = __webpack_public_path__ + "img/front.55564938.png";